import { use } from 'react';
import { WalletContext } from './WalletContext';

export function useWallet() {
  const ctx = use(WalletContext);
  if (!ctx) throw new Error('useWallet must be used within WalletProvider');
  return ctx;
}
